
    import { defineComponent } from 'vue'
    import { useRoute } from 'vue-router'
    import router from '@/router'
    import { useSessionStore } from '@/store/session'

    import { AuthenticationApi, StringUtil } from '@/util'
    import { AxiosError, AxiosResponse, HttpStatusCode } from 'axios'
    import { ILoginResultDTO } from '@/types/auth'

    export default defineComponent({
        name: 'DeviceLogin',

        setup() {
            /********************************************************************************************************************
             PRIVATE DATA
             ********************************************************************************************************************/
            const route = useRoute()
            const serialNoFromUrl = route.query.id as string

            /********************************************************************************************************************
             PRIVATE METHODS
             ********************************************************************************************************************/
            function getDeviceToken(serialNumber: string) {
                const api = new AuthenticationApi()

                api.getDeviceToken(serialNumber)
                    .then(response => handleResponse(response, serialNumber))
                    .catch(error => {
                        if (error instanceof AxiosError && error.response != null) {
                            handleResponse(error.response, serialNumber)
                        }
                    })
            }

            function handleResponse(response: AxiosResponse<ILoginResultDTO>, serialNumber: string) {
                const sessionStore = useSessionStore()

                if (response.status === HttpStatusCode.Ok) {
                    sessionStore.setDeviceLogin(response.data, serialNumber)
                    router.push({ name: 'equipment-documents', params: { sn: serialNumber } })
                    return
                }

                // Redirect to combined login with S/N pre-filled and error key
                let errorKey = 'UnexpectedError'
                if (response.status === HttpStatusCode.Unauthorized) errorKey = 'UnknownDevice'
                else if (response.status === HttpStatusCode.Forbidden) errorKey = 'AccessBlocked'

                router.replace({ name: 'combined-login', query: { sn: serialNumber, deviceError: errorKey } })
            }

            /********************************************************************************************************************
             INITIALIZATION
             ********************************************************************************************************************/
            if (StringUtil.hasContent(serialNoFromUrl)) {
                getDeviceToken(serialNoFromUrl.trim())
            } else {
                router.replace({ name: 'combined-login' })
            }

            return {}
        }
    })
